import http from "@/http/aisea/axios";
const resource = "/hull_insurance/enterprises/claim_reports";

export default {
  fetchList(claimReportId) {
    return http.get(`${resource}/${claimReportId}/claim_types`);
  },
  fetchDetail(claimReportId, claimReportTypeId) {
    return http.get(
      `${resource}/${claimReportId}/claim_types/${claimReportTypeId}`
    );
  },
  delete(claimReportId, claimReportTypeId) {
    return http.delete(
      `${resource}/${claimReportId}/claim_types/${claimReportTypeId}`
    );
  },
  add(claimReportId, claimTypeId) {
    return http.post(`${resource}/${claimReportId}/claim_types`, {
      claim_type_id: claimTypeId,
    });
  },
  uploadFile(claimReportId, claimReportItemId, file) {
    return http.post(
      `${resource}/${claimReportId}/claim_items/${claimReportItemId}/files`,
      file,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
  },
  deleteFile(claimReportId, claimReportItemId, fileName) {
    return http.delete(
      `${resource}/${claimReportId}/claim_items/${claimReportItemId}/files`,
      {
        data: {
          file_name: fileName,
        },
      }
    );
  },
  downloadAll(claimReportId, claimReportTypeId) {
    return http.get(
      `${resource}/${claimReportId}/claim_types/${claimReportTypeId}/files`,
      {
        responseType: "arraybuffer", // レスポンスをバイナリデータとして取得
      }
    );
  },
  downloadFile(claimReportId, claimReportItemId, fileName) {
    return http.get(
      `${resource}/${claimReportId}/claim_items/${claimReportItemId}/files/${fileName}`,
      {
        responseType: "arraybuffer",
      }
    );
  },
  updateClaimReportClaimType(claimReportId, claimReportTypeId, claimTypeId) {
    return http.put(
      `${resource}/${claimReportId}/claim_types/${claimReportTypeId}`,
      {
        claim_type_id: claimTypeId,
      }
    );
  },
  updateClaimReportItem(claimReportId, claimReportItemId, payload) {
    return http.put(
      `${resource}/${claimReportId}/claim_items/${claimReportItemId}`,
      payload
    );
  },
  updateClaimReportTypeStepItem(
    claimReportId,
    claimReportTypeId,
    claimReportTypeStepId,
    claimReportTypeStepItemId,
    payload
  ) {
    return http.put(
      `${resource}/${claimReportId}/claim_types/${claimReportTypeId}/steps/${claimReportTypeStepId}/items/${claimReportTypeStepItemId}`,
      payload
    );
  },
};
